// Dependencies
import { Types } from '../types';
import _ from 'lodash';

// TODO: Allow to override any of these values from config
const breakpointsMap: any = {
	desktop: {
		lg: '1366px',
		md: '1280px',
		sm: '1100px',
	},
	tablet: {
		lg: '1024px',
		md: '921px',
		sm: '768px',
	},
	mobile: {
		lg: '550px',
		md: '475px',
		sm: '375px',
	}
}

export const getFormattedValue = (value: string | number) => `${value.toString()}${! value.toString().match(/(var|em|rem|px|ch|%|in|cn|mm|pt|pc|ex)/) ? 'em' : ''}`

export const
	clamp = (prop: string, min: number, max: number, base: number | undefined = 5, important = false) => (`
		${prop}: ${Math.floor((min + max) / 2)}em;
		@supports(${prop}: clamp( ${min}em, ${base}vw, ${max}em) ) {
			${prop}: clamp(${min}em, ${base}vw, ${max}em)${important ? ` !important` : ''};
		}
	`),
	getAttributeValuesAsArray = (values: any) => Object.fromEntries( Object.entries(values).map(([key, value]) => [key, [value]]) ),
	getBreakpoint = (device: string, size: string) => breakpointsMap[device][size] || null,
	getNavButtonIcon = (direction: 'prev' | 'next') => direction === 'prev' ? '<' : '>';

export const getRoundedPrice = (price: number, precision: number = 2) => parseFloat( ( Math.round((price + Number.EPSILON) * 100) / 100 ).toFixed(Math.abs(precision) ) );

export const getPrice = ({price, quantity, taxClass, taxRates, displayMode, precision}: {price: number, quantity: number, taxClass: 'standard' | 'zero', taxRates: {[taxClass: string]: number}, displayMode: 'include' | 'exclude', precision: number }) => {
	
	// We need to know:
	// - price (per unit, expecting excluding tax)
	// - quantity
	// - priceTaxClass || defaultTaxClass
	// - taxRates[priceTaxClass]
	// - displayMode

	let calculatedPrice = price; // base price per unit

	// Include tax when needed 
	if ( displayMode === 'include' ) {
		if ( taxClass in taxRates ) {
			calculatedPrice = calculatedPrice * taxRates[taxClass];
		}
	}
	
	// Round price 
	// NOTE: Should we also choose the right rounding function (i. e. CZK should be proably ceiled or rounded? >> now works as intended)
	// NOTE: Moved to getRoundedPrice for usage in spring interpolation
	//calculatedPrice = Number( ( Math.round((calculatedPrice + Number.EPSILON) * 100) / 100 ).toFixed(Math.abs(precision)) );

	// Apply quantity (non-zero)
	calculatedPrice *= Math.abs(quantity) || 1;

	// Return calculate price
	// return calculatedPrice.toFixed(2);
	return calculatedPrice;
	
}  

export const Timer: any = {
	timers: {},
	setStartTime: (id: any, reset = false) => {
		if (reset && id in Timer.timers) {
			Timer.timers[id] = {}
		}
		Timer.timers = {
			...Timer.timers, ...{
				[id]: {
					start: window.performance.now(),
					end: null
				}
			}
		}
	},
	setEndTime: (id: any) => {
		if ( ! (id in Timer.timers) ) {
			return;
		}
		Timer.timers = {
			...Timer.timers, ...{
				[id]: {
					start: Timer.timers[id].start,
					end: window.performance.now()
				}
			}
		}
	},
	start: (id: any) => {
		Timer.setStartTime(id);
	},
	stop: (id: any, log = true) => {
		Timer.setEndTime(id);
		if (log) return Timer.log(id)
	},
	reset: (id: any) => {
		Timer.setStartTime(id, true);
		Timer.setEndTime(id, true)
	},
	getTime: (id: any, reset = true) => {
		if (!(id in Timer.timers)) return null;
		const elapsedTime = Timer.timers[id].end - Timer.timers[id].start;
		if (reset) Timer.reset(id);
		return elapsedTime; 
	},
	log: (id: any, reset = false) => `${id}: ${Timer.getTime(id, reset)}ms`
}